"use strict";
// 借鉴的是：https://github.com/moll/json-stringify-safe/blob/master/stringify.js
// 让JSON.stringify 在循环引用时不报错
Object.defineProperty(exports, "__esModule", { value: true });
function stringify(obj, replacer, spaces, cycleReplacer) {
    try {
        return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
    }
    catch (e) {
        console.error("[sls-web-track-stringify]：", e);
    }
    return "";
}
function serializer(replacer, cycleReplacer) {
    var stack = [];
    var keys = [];
    if (cycleReplacer == null)
        cycleReplacer = function (_key, value) {
            if (stack[0] === value)
                return "[Circular ~]";
            return "[Circular ~.".concat(keys.slice(0, stack.indexOf(value)).join("."), "]");
        };
    return function (key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value))
                // rome-ignore lint/suspicious/noExplicitAny: <explanation>
                value = cycleReplacer.call(this, key, value);
        }
        else
            stack.push(value);
        return replacer == null ? value : replacer.call(this, key, value);
    };
}
exports.default = stringify;
